module.exports = __webpack_public_path__ + "static/nuvista-0dce4239a572e79e9f795f1a8f4c32f0.jpg";